import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { registerSW } from './registerSW';
import { setupTelegramViewport } from './telegram/viewport';
import './index.css';

// До рендера: если открыты как Telegram Mini App — развернуть на весь экран и
// запретить закрытие вертикальным свайпом (иначе прокрутка роняет приложение).
setupTelegramViewport();

const root = document.getElementById('root');
if (!root) throw new Error('#root не найден');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerSW();
